import { render, staticRenderFns } from "./PublisherPage.vue?vue&type=template&id=5d400159&"
import script from "./PublisherPage.vue?vue&type=script&lang=js&"
export * from "./PublisherPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports